import React, { useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';
import './DonationButtonTooltip.styles.css'; // Create this file for styles

interface DonationButtonTooltipProps {
  tooltipLabel: string;
  targetElement: HTMLElement;
  isMegaMenu?: boolean;
  id: string; // For aria-describedby
  parentClass?: string;
}

const DonationButtonTooltip = ({
  tooltipLabel,
  targetElement,
  isMegaMenu,
  id,
  parentClass,
}: DonationButtonTooltipProps) => {
  const [arrowLeft, setArrowLeft] = useState(0);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const calculatePosition = () => {
      if (targetElement && tooltipRef.current) {
        const targetRect = targetElement.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();

        const targetCenter = targetRect.left + targetRect.width / 2;
        const calculatedArrowLeft = targetCenter - tooltipRect.left;
        setArrowLeft(calculatedArrowLeft);
      }
    };

    calculatePosition(); // Initial calculation

    // Recalculate on window resize
    window.addEventListener('resize', calculatePosition);
    return () => {
      window.removeEventListener('resize', calculatePosition);
    };
  }, [targetElement, tooltipLabel]); // Rerun if targetElement or tooltipLabel changes

  if (!tooltipLabel) {
    return null; // Don't render if no label
  }

  // const getMegaMenuYPos = () => {
  //   const megaMenuElement = document.querySelector('[data-radix-popper-content-wrapper]');
  //   if (megaMenuElement) {
  //     const rect = megaMenuElement.getBoundingClientRect();
  //     return rect.top;
  //   }
  //   return 0;
  // };

  // const menuYPos = isMegaMenu ? getMegaMenuYPos() : 0;
  // const rect = targetElement.getBoundingClientRect(); // This is now inside useEffect

  return (
    <div
      id={id}
      ref={tooltipRef}
      role="tooltip"
      className={clsx('donationButtonTooltip', parentClass)}
    >
      {tooltipLabel}
      <span
        className="donationButtonTooltip__arrow"
        style={{
          left: `${arrowLeft}px`,
        }}
      ></span>
    </div>
  );
};

export default DonationButtonTooltip;
